import React from 'react';
import { useParams } from 'react-router-dom';
import { AuthData } from '../../../context/auth';
import {
	EndorsementData,
	withEndorsementContext,
} from '../../../context/EndorsementProvider';
import AddedPerilDetails from './AddedPerilDetails';
import ExistingPerilDetails from './ExistingPerilDetails';

interface Props {
	authData: AuthData;
	endorsementData: EndorsementData;
}

/**
 * The rendered route component to decide between AddedPerilDetails or ExistingPerilDetails
 */
const Peril = (props: Props) => {
	const params = useParams();
	const { perilId } = params;
	const perilIsAdded = perilId.split('-')[0] === 'added';

	if (perilIsAdded) {
		return <AddedPerilDetails />;
	}

	return <ExistingPerilDetails />;
};

export default withEndorsementContext<Props>(Peril);
